import React from 'react'
import styled from 'styled-components'

interface PropsType {
  batchOperation: React.ReactNode
}

const BatchPanel: React.FC<PropsType> = ({ batchOperation }) => (
  <Container>{batchOperation}</Container>
)

export default BatchPanel

const Container = styled.div`
  width: 100%;
  height: 32px;
  background: #ecebf9;
  border-radius: 6px;
  border: 1px solid #aca7e8;
  margin-bottom: 12px;
`
